export default from './AutoCalculation';



// WEBPACK FOOTER //
// ./src/sharedComponents/LoanOptions/components/BidPage/components/AutoCalculation/index.js